import { drawingStore } from "../store";

export const getSelectedTool = () => {
  const state = drawingStore.reduxStore?.store.getState();
  if (!state) return;

  return state.toolbar.selectedTool;
};
